export default __webpack_public_path__ + "images/SU.8847e8f.png";